import { render, staticRenderFns } from "./DomainSelectModal.vue?vue&type=template&id=3c634826&scoped=true"
import script from "./DomainSelectModal.vue?vue&type=script&lang=ts"
export * from "./DomainSelectModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c634826",
  null
  
)

export default component.exports